import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import SampleInlineComment from '@features/sampleDevelopment/components/SampleInlineComment';

import { changeDateFormat, isPatternMaster } from '@utils/Util';

const TableBodyForPatternMaster = ({
	setDesignIdToView,
	setActiveRemarksId,
	item,
	handlePageRoute,
	activeRemarksId,
	setShowComment,
	setCurrentActivePage,
	setSelectedId,
	renderSampleSizeAndQty,
	handleComplete,
	id
}) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	return (
		<tr>
			<td>
				<div className="d-flex align-items-center">
					<img src={item?.featureImageDocUrl} alt="" className="cell-img pr-2" />
					<span
						className="d-inline-block align-middle ml-1 cursor-pointer"
						onClick={() => setDesignIdToView(item.productId)}
						data-toggle="modal"
						data-target="#designViewModal"
					>
						<p className="regular-12 weight-500 gray_dark_01 mb-1">{item?.referenceNumber}</p>
						<ul className="common-list-component mb-1">
							{item?.market && <li>{item?.market}</li>}
							{item?.category && <li>{item?.category} </li>}
						</ul>
						<ul className="common-list-component">
							{item?.productCreator && <li>{item?.productCreator}</li>}
							{item?.productCreationDate && (
								<li>
									{changeDateFormat(item?.productCreationDate, 'DD-MM-YYYY', 'Do MMM, YY')}
								</li>
							)}
						</ul>
					</span>
				</div>
			</td>
			<td>
				{item?.requireDate && (
					<p className="regular-14 gray_dark_02">
						<span>RQD</span>
						<span className="gray_dark_01 ml-2">
							{changeDateFormat(item?.requireDate, 'YYYY-MM-DD', 'DD MMM')}
						</span>
					</p>
				)}
			</td>
			<td>
				<div className="sample-details">{renderSampleSizeAndQty(item)}</div>
			</td>
			<td>
				<p className="regular-12 gray_dark_01">{item?.cuttingActivityResponse?.assignedToName}</p>
				{item?.cuttingActivityResponse?.requiredDate && (
					<p className="regular-12 primary_bright_02">
						{changeDateFormat(
							item?.cuttingActivityResponse?.requiredDate,
							'YYYY-MM-DD',
							'DD MMM'
						)}
					</p>
				)}
				{item?.cuttingActivityResponse?.deliveryDate && (
					<p className="regular-12 green">
						{changeDateFormat(
							item?.cuttingActivityResponse?.deliveryDate,
							'YYYY-MM-DD',
							'DD MMM'
						)}
						<img
							src={`${process.env.PUBLIC_URL}/icons/check.svg`}
							alt="done"
							className="checked"
						/>
					</p>
				)}
				{item?.cuttingActivityResponse?.status === 'PENDING' && (
					<div className="hover-btn">
						<button
							onClick={() =>
								handleComplete(item?.cuttingActivityResponse?.activityType, item?.id)
							}
							className="button approve size32"
						>
							Complete
						</button>
					</div>
				)}
			</td>
			{!isPatternMaster() && (
				<td>
					<div className="hover-btn">
						<button
							onClick={() => {
								handlePageRoute();
								navigate(
									`/designs/edit/${item?.productId}?activeTab=measurement&requestFrom=sample`
								);
							}}
							className="button size32"
						>
							Measurement
						</button>
					</div>

					{item?.isMeasurementCompleted && (
						<img
							src={`${process.env.PUBLIC_URL}/icons/check.svg`}
							alt="done"
							className="checked"
						/>
					)}
				</td>
			)}
			<td className="country-inhouse-factory">
				<span>{item?.unitResponse?.name}</span>
			</td>
			<td onClick={() => setActiveRemarksId(item?.id)}>
				<SampleInlineComment
					id={item?.id}
					sampleRequestId={id}
					remarks={item?.remarks}
					activeRemarksId={activeRemarksId}
					onReset={() => setActiveRemarksId(null)}
				/>
			</td>
			<td>
				<div className="col-md-1 one-sixth text-right">
					<button
						className="button text cursor-pointer"
						onClick={() => {
							dispatch(
								setCurrentActivePage({
									id: item?.productId,
									type: 'PRODUCT_CONVERSATION',
									pageType: 'DETAILS'
								})
							);
							setSelectedId(item?.productId);
							setShowComment(true);
						}}
					>
						{item?.noOfUnreadMessage > 0 ? (
							<img
								src={`${process.env.PUBLIC_URL}/icons/comment-not-read.svg`}
								alt="not read"
							/>
						) : (
							<img src={`${process.env.PUBLIC_URL}/icons/comments-gray.svg`} alt="not read" />
						)}
					</button>
				</div>
			</td>
		</tr>
	);
};

export default TableBodyForPatternMaster;
